import { ComponentLoadingState, LoadingTypes } from '@labrav/common'

export const isLoading =
  (loadingState: ComponentLoadingState) => (label: LoadingTypes | string) =>
    (loadingState[label] || 0) > 0
